<template>
    <div>
        <div class="font-weight-bold h3 mb-3">
            {{ __('general.contact_info') }}
        </div>

        <div class="row">
            <div class="col-md-6">
                <FormGroupNew :label="__('general.email')"
                              :error="value.errors.email"
                >
                    <input type="email"
                           class="form-control"
                           placeholder="mustermail@domain.de"
                           v-model="localForm.email"
                    >
                </FormGroupNew>
            </div>
            <div class="col-md-6">
                <FormGroupNew :label="__('general.phone')"
                              :error="value.errors.phone"
                >
                    <input type="text"
                           class="form-control"
                           placeholder="(0681) 123456"
                           v-model="localForm.phone"
                    >
                </FormGroupNew>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6">
                <FormGroupNew :label="__('sale.delivery_note_info.poBox')"
                              :error="value.errors.poBox"
                >
                    <input type="text"
                           class="form-control"
                           placeholder="Mustergeschäft, Postfach 10 30 40, 66132 Musterstadt"
                           v-model="localForm.poBox"
                    >
                </FormGroupNew>
            </div>
            <div class="col-md-6">
                <FormGroupNew :label="__('general.fax')"
                              :error="value.errors.fax"
                >
                    <input type="text"
                           class="form-control"
                           placeholder="(0681) 123456"
                           v-model="localForm.fax"
                    >
                </FormGroupNew>
            </div>
        </div>
    </div>
</template>

<script>
import FormGroupNew from "@components/Form/FormGroupNew.vue";

export default {
    components: {FormGroupNew},

    props: {
        value: Object
    },

    data() {
        return {
            localForm: this.value
        };
    },

    watch: {
        localForm: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit('input', newValue)
            }
        }
    }
}
</script>
